export const EMAIL_CLAIM = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';

// Decode only; the account app validates the token.
export const decodeJwtClaims = (token: string): Record<string, unknown> | null => {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }

  try {
    const binary = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    // atob yields Latin-1; re-decode the bytes as UTF-8.
    const json = decodeURIComponent(
      Array.from(binary, (c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')).join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

// The account app signs in without B2C only with an unexpired access token or a refresh token.
export const hasUsableSession = (
  expireTime: string | null,
  refreshToken: string | null,
  now: number = Date.now()
): boolean => {
  if (refreshToken) {
    return true;
  }
  // Number, not parseInt, so a corrupted value like '123abc' does not count as a valid expiry.
  const parsedExpireTime = Number(expireTime);
  return expireTime !== null && Number.isFinite(parsedExpireTime) && parsedExpireTime > now;
};

export const buildAutoLoginUrl = (baseUrl: string, email?: string): string => {
  const url = new URL(baseUrl, globalThis.location?.origin);
  url.searchParams.set('autologin', 'true');
  if (email) {
    url.searchParams.set('login_hint', email);
  }
  return url.toString();
};
